import { normalizeUrlPathname } from "lopermut"
import z from "zod"

const WidgetDisplayUrlsSchema = z
  .array(z.string())
  .transform((urls) => urls.map(normalizeUrlPathname).filter(Boolean))
  .default([])

export const IframeChatPhoneSchema = z.object({
  image: z.string().url(),
  padding: z.string().default("50px 10px 20px 10px"),
  iframePadding: z.string().default("0"),
  borderRadius: z.string().default("10px"),
  aspectRatio: z.string().default("390 / 640"),
})

export const IframeChatConfigResponseData = z.object({
  phone: IframeChatPhoneSchema.default({
    image: "https://production-permut.s3.eu-west-3.amazonaws.com/widget/phones/iphone-15-pro.png",
    padding: "24px 55px 23px",
    iframePadding: "0",
    borderRadius: "34px",
    aspectRatio: "370 / 608",
  }),
  background: z
    .object({
      color: z.string().default("transparent"),
      image: z.string().optional().or(z.literal("")),
      position: z.string().default("center center"),
      size: z.string().default("cover"),
    })
    .default({ color: "transparent", position: "center center", size: "cover" }),
})

export const GetWidgetConfigurationResponseData = z.object({
  theme: z.enum(["default", "simple"]).default("default"),
  hideCompanyLogo: z.boolean().optional(),
  user: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .default({ backgroundColor: "#3C96B2", color: "#FFFFFF" }),
  assistant: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .default({ backgroundColor: "#F5F5F5", color: "#171717" }),
  actions: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .default({ backgroundColor: "#D4E6EC", color: "#3C96B2", borderColor: "#3C96B2" }),
  dialog: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .default({ backgroundColor: "#FFFFFF" }),
  displayDelay: z.number().default(500),
  bubble: z
    .object({
      backgroundColor: z.string().default("#B3D2DC"),
      color: z.string().default("#FFFFFF"),
      displayDelay: z.number().default(1500),
      removeAfter: z.number().default(0),
      removeOnDesktop: z.boolean().optional(),
      messages: z.record(z.string(), z.array(z.string()).optional()).optional(),
    })
    .prefault({}),
  companyDescription: z
    .object({
      display: z.boolean().default(true),
      text: z.string().optional(),
      texts: z.record(z.string(), z.string()).optional(),
    })
    .prefault({}),
  buttonImage: z.string().optional(),
  position: z
    .object({
      bottom: z.number().default(20),
      left: z.number().nullish(),
      right: z.number().default(20).nullish(),
      zIndex: z.number().default(1),
    })
    .prefault({}),
  openingMessage: z.record(z.string(), z.string()).optional(),
  quickActions: z.record(z.string(), z.array(z.string()).optional().default([])).optional(),
  languages: z
    .array(z.object({ label: z.string(), value: z.string() }))
    .default([{ label: "English", value: "en" }]),
  fullscreen: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .default({ backgroundColor: "#f5f5f4" }),
  hasWatermark: z.boolean().optional().default(true),
  bubbleImage: z.string().nullish(),
  sendBehavior: z.enum(["clickToSend", "enterToSend"]).default("enterToSend"),
  typingLabel: z.record(z.string(), z.array(z.string().min(1))).optional(),
  typingIndicatorStyle: z.enum(["dots", "cycling"]).default("cycling"),
  displayUrls: WidgetDisplayUrlsSchema,
})

export const UploadBubbleImageResponseData = z.object({
  url: z.string(),
})

export const UploadIframeBackgroundImageResponseData = z.object({
  url: z.string(),
})
